import { useQuery } from '@hooks/reactQuery';

import { getOrganisationCategories } from '@api/common';

import { organisationCategoriesFormatted } from '@utils/formatter';

import { ICategory } from '@interfaces/organisation/organisations';

import { refetchOptions } from '@constants/common';
import { CATEGORIES } from '@constants/queryKeys';

export const useQueryOrganisationCategories = () => {
	const {
		data: organisationCategories,
		isLoading: isLoadingCategories,
		isFetching: isFetchingCategories,
	} = useQuery({
			queryKey: [CATEGORIES],
			queryFn: getOrganisationCategories,
			select: (categories: Array<ICategory>) => organisationCategoriesFormatted(categories),
			...refetchOptions,
		},
	);

	return {
		isLoadingCategories: isLoadingCategories || isFetchingCategories,
		organisationCategories: organisationCategories || [],
	};
};
